import React, { useCallback, useState } from 'react'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BlueButton from 'components/inputs/BlueButton'
import { PAGE_URL_CATALOG } from 'SiteURLs'
import { useCart } from 'cart/CartProvider'
import { CartProductList } from 'product'

interface ICartProductsPhaseProps {
  toNextPhase: VoidFunction
  disabled: boolean
}

const CartProductsPhase: React.FC<ICartProductsPhaseProps> = ({
  toNextPhase,
  disabled,
}) => {
  const [cart, cartAct] = useCart()
  const [isLoading, setIsLoading] = useState(false)

  const handleChangeProductOrder = useCallback(
    (product, quantity) => {
      setIsLoading(true)
      cartAct.changeProductQuantity(product, quantity, () => {
        setIsLoading(false)
      })
    },
    [cartAct]
  )

  const handleRemove = useCallback(
    (product) => {
      setIsLoading(true)
      cartAct.removeProduct(product, () => {
        setIsLoading(false)
      })
    },
    [cartAct]
  )

  return (
    <>
      {cart && (
        <>
          {cart.products.length === 0 ? (
            <>
              <h3>Пока пусто</h3>
              <BlueButton href={'#/' + PAGE_URL_CATALOG}>К товарам</BlueButton>
            </>
          ) : (
            <>
              <CartProductList
                products={cart.products}
                isLoading={isLoading}
                onRemoveProduct={handleRemove}
                onChangeProductQuantity={handleChangeProductOrder}
              />

              <div className='d-flex justify-content-center my-3'>
                <BlueButton
                  onClick={toNextPhase}
                  style={{ paddingLeft: '30px', paddingRight: '30px' }}
                >
                  <>
                    {'Продолжить  '}
                    <FontAwesomeIcon icon={faArrowRight} />
                  </>
                </BlueButton>
              </div>
            </>
          )}
        </>
      )}
    </>
  )
}
export default CartProductsPhase
